module.exports = __webpack_public_path__ + "img/round2-option1.28546b8b.png";